import React from 'react'
import DefaultLayout from '../DefaultLayout'

const CurrentProbremWrapper = () => {
    return (
        <div className='py-14 sm:py-20 text-main-800'>
            <DefaultLayout className='px-6'>
                <div className='grid gap-10'>
                    <div>
                        <h2 className='text-2xl sm:text-3xl font-semibold'>
                            正しく「計測」するのに多くのお金・時間・苦痛を伴っていた
                        </h2>
                    </div>
                    <p className='text-xl font-semibold leading-8'>
                        大切なものとはわかっていながらもちゃんと寝れているかどうか把握している人は少ない。<br />
                        それは、これまで「計測」する方法が確立していなかったから。
                    </p>
                </div>
            </DefaultLayout>
        </div>
    )
}

export default CurrentProbremWrapper